'use strict';

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

require('swiper/dist/css/swiper.min.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

$(function () {
	//hover状态
	$(".title_lev_2 > li").hover(function () {
		$(this).addClass('active').siblings().removeClass('active');
		$(this).parents('.information').find('.information_links_box').eq($(this).index()).show().siblings('.information_links_box').hide();
	});
	//轮播图处理
	var swipersObj = {
		ids: []
	};
	$('.swiper-container').each(function (i) {
		swipersObj.ids.push($(this).attr('categoryId'));
	});
	swipersObj.ids.forEach(function (item, index) {
		//创建轮播对象
		swipersObj['swiper_' + item] = new _swiper2["default"]('#swiper_' + item, {
			slidesPerView: 5,
			nextButton: '#arrow-right_' + item,
			prevButton: '#arrow-left_' + item,
			loop: true
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/js/home_informationList.js
// module id = 83
// module chunks = 4